import { useContext } from 'react';
import { OrderContext } from '@context';

export const useOrderContext = () => {
  const context = useContext(OrderContext);
  return context;
};
